module.exports = __webpack_public_path__ + "img/madera016.e7dd17f1.jpg";